import { ProjectDetail, ProjectListItem } from '../types/content';
import { createPublicCatalogCache } from './publicCatalogCache';

export const projectCatalogCache = createPublicCatalogCache<ProjectListItem, ProjectDetail>();

export function splitSearchTokens(search?: string) {
  return (search || '')
    .split(/[\s,;]+/)
    .map((part) => part.trim().toLowerCase())
    .filter((part) => part.length > 0)
    .filter((part, index, all) => all.indexOf(part) === index);
}

export function filterPublicProjects(
  projects: ProjectListItem[],
  opts: {
    search?: string;
    categoryId?: string | number;
    difficulty?: string;
    engagementType?: string;
  }
) {
  const tokens = splitSearchTokens(opts.search);
  const categoryId = opts.categoryId ? String(opts.categoryId) : '';
  const difficulty = (opts.difficulty || '').trim();
  const engagementType = (opts.engagementType || '').trim();

  return projects.filter((project) => {
    if (categoryId && String(project.categoryId || '') !== categoryId) return false;
    if (difficulty && project.difficulty.toLowerCase() !== difficulty.toLowerCase()) return false;
    if (engagementType && project.engagementType.toLowerCase() !== engagementType.toLowerCase()) return false;
    if (!tokens.length) return true;
    const haystack = [
      project.title,
      project.subtitle,
      project.summary,
      project.company,
      project.location,
      project.engagementType,
      project.estimatedHours,
      project.teamType,
      project.techStack,
      project.categoryName,
      project.difficulty,
      ...(project.tags || []),
    ]
      .map((value) => (value || '').toLowerCase())
      .join(' ');
    return tokens.every((token) => haystack.includes(token));
  });
}
